import { Component, Input, Inject, OnInit, Output, EventEmitter } from "@angular/core";

@Component({
	selector: 'form-case-entry-proposal',
	templateUrl: './form-case-entry-proposal.component.html',
})
export class FormCaseEntryProposalComponent implements OnInit {

  @Output()
  callbackRegister = new EventEmitter();
  @Input()
  public data: any;

  constructor() {
    this.isValid = this.isValid.bind(this);
  }

  ngOnInit() {
    this.callbackRegister.emit({
      isValid: this.isValid,
    });
    this.data.entryProposalDate = new Date();
  }

  isValid() {
    return !!this.data.entryProposalDate;
  }
}
